import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const handleError = (err: any) => {
  if (err.response && err.response.data) {
    const responseData = err.response.data;
    if (responseData.errors) {
      const errors = responseData.errors;

      // Case 1: errors is a string
      if (typeof errors === "string") {
        toast.error(responseData.message, {
            autoClose: 3000,
          }); 
      }
      // Case 2: errors is an array of strings
      else if (Array.isArray(errors) && errors.every((item) => typeof item === "string")) {
        errors.forEach((error) => {
            toast.error(error, {
                autoClose: 3000,
              });
        });
      }
      // Case 3: errors is an object (which can have deeper nesting)
      else if (typeof errors === "object") {
        // Check if the errors object is empty
        if (Object.keys(errors).length === 0) {
          // Handle case where errors is an empty object
          toast.error(responseData.message || "An unexpected error occurred", {
            autoClose: 3000,
          });
        } else {
          const traverseErrors = (obj: any, parentKey: string = '') => {
            Object.keys(obj).forEach((key) => {
              const value = obj[key];

              if (Array.isArray(value)) {
                // If the value is an array, iterate over its elements
                value.forEach((item) => {
                  if (typeof item === "string") {
                    // If the array contains strings (error messages)
                    toast.error(`${parentKey}${key}: ${item}`, {
                        autoClose: 3000,
                      });
                  } else if (typeof item === "object") {
                    // If the array contains objects (like { quantity_invalid: "some message" })
                    Object.keys(item).forEach((nestedKey) => {
                        toast.error(`${nestedKey}: ${item[nestedKey]}`, {
                            autoClose: 3000,
                          });
                    });
                  }
                });
              } else if (typeof value === "object") {
                // If the value is an object, recurse into it
                traverseErrors(value, `${parentKey}${key}.`);
              }
            });
          };

          // Traverse and display nested errors
          traverseErrors(errors);
        }
      }
    } else {
      // If there's no `errors` key in the response
      toast.error(responseData.message || "An unexpected error occurred", {
        autoClose: 3000,
      });
    }
  } else {
    // Handle network or non-response errors
    toast.error(err.message || "An unexpected network error occurred", {
        autoClose: 3000,
      });
  }
};

export default handleError;
